// third-party
import { createSlice } from '@reduxjs/toolkit';
import { Filters } from 'react-table';

// project import
import EventDto from 'common/dto-types/event-dto';
import { PaginationParam, SortingParam, SortingType } from 'components/base-table/dto';
import { DefaultVisibleEventColumns } from 'pages/event-list-page/event-column-config';

type EventSliceStates = {
    data?: EventDto;
    isFormOpen: boolean;
    updates: number;
    filters: Filters<any>;
    sorting: SortingParam;
    pagination: PaginationParam;
    visibleColumns: Array<string>;
};

const initialState: EventSliceStates = {
    isFormOpen: false,
    updates: 0,
    filters: [],
    sorting: { sortingType: SortingType.Descending, sortBy: 'startDate', searchTerm: '' },
    pagination: { pageSize: 10, pageIndex: 0 },
    visibleColumns: DefaultVisibleEventColumns,
};

const event = createSlice({
    name: 'event',
    initialState,
    reducers: {
        openEventForm(state) {
            state.isFormOpen = true;
            state.updates += 1;
        },

        closeForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
            state.updates += 1;
        },

        setEvent(state, action) {
            state.data = action.payload;
        },

        setEventListFilters(state, action) {
            state.filters = action.payload;
        },
        setEventListSortingAndPagination(state, action) {
            state.sorting = action.payload.sorting;
            state.pagination = action.payload.pagination;
        },
        setEventColumnsPersistence(state, action) {
            state.visibleColumns = action.payload;
        },
    },
});

export default event.reducer;

export const {
    openEventForm,
    closeForm,
    setEvent,
    setEventListFilters,
    setEventListSortingAndPagination,
    setEventColumnsPersistence,
} = event.actions;
